//
//
//
//
//
//

export default {
  name: 'DpSeparator',
};
